export default __webpack_public_path__ + "static/media/Aadhira Velli Maligai Logo.e79db579.png";